import React from 'react';
import { connect } from 'react-redux';
import getLocale from '@ali/brokkoli/lib/utils/get_locale';
import shuffle from 'lodash.shuffle';
import { route } from '@ali/react-router-lite';
import { SET_ANSWER, SET_QUESTION_ORDER } from '../actions/index';
import log from '@ali/log';

import './page_answer.styl';

const pg = 'examSheet';

class PageAnswer extends React.Component {

  constructor(props) {
    super(props);

    let questionOrder = this.getAllAnswer().map((item, index) => index);
    const currentUserAnswer = this.getAllAnswer().map(() => -1);
    const { isShuffleQuestion, shuffleQuestionAmount } = this.props;

    if (isShuffleQuestion) {
      if (shuffleQuestionAmount) {
        questionOrder = shuffle(questionOrder).slice(0, shuffleQuestionAmount);
      }
      questionOrder = shuffle(questionOrder);
    }
    console.log(questionOrder);
    this.props.setQuestionOrder(questionOrder);
    this.state = {
      questionOrder,
      currentIndex: 0,
      currentUserAnswer,
    };
    this.questionLength = this.state.questionOrder.length;
    this.allBackgroundUrl = this.getAllBackgroundUrl();
    this.allAnswer = this.getAllAnswer();
    this.allOption = this.getAllOption();
    this.allQuestion = this.getAllQuestion();
  }

  componentDidMount() {
    log.logVisit(pg, {
      exam: 0,
    });
  }

  getRem(px) {
    return px / 1000 + 'rem';
  }

  getMatchValueArray(object, matcher) {
    const result = [];
    const objectKeys = Object.keys(object);
    objectKeys.forEach(value => {
      if (matcher.test(value)) {
        result.push(object[value]);
      }
    });
    return result;
  }

  getAllAnswer() {
    const macher = /question_right_answer/;
    const object = getLocale('page_qna');
    return this.getMatchValueArray(object, macher);
  }

  getAllBackgroundUrl() {
    const macher = /question_bg/;
    const object = getLocale('page_qna');
    return this.getMatchValueArray(object, macher);
  }

  getAllOption() {
    const macher = /question_answer/;
    const object = getLocale('page_qna');
    return this.getMatchValueArray(object, macher);
  }

  getAllQuestion() {
    const macher = /question_title/;
    const object = getLocale('page_qna');
    return this.getMatchValueArray(object, macher);
  }

  getCurrentBackgroundUrl(order) {
    return this.allBackgroundUrl[order];
  }

  getCurrentOption(order) {
    return this.allOption[order];
  }

  getCurrentQuestion(order) {
    return this.allQuestion[order];
  }

  getCurrentAnswer(order) {
    return Number(this.allAnswer[order]);
  }

  getQuestionOrder(pageIndex) {
    const { questionOrder } = this.state;
    return this.getArrayItem(questionOrder, pageIndex);
  }

  getArrayItem(array, index) {
    if (typeof array === 'undefined') {
      return '';
    }
    return array[index];
  }

  // getSerialNumber(index) {
  //   const serialNumberArray = [ 'A', 'B', 'C' ];
  //   return this.getArrayItem(serialNumberArray, index);
  // }

  getOptionBackgroundUrl(optionIndex, pageIndex) {
    const { imgCdnPrefix } = this.props;
    const { currentUserAnswer } = this.state;
    const defaultOptionBackgroundUrl = `${imgCdnPrefix}word-option-default.png`;
    const activeOptionBackgroundUrl = `${imgCdnPrefix}word-option-active.png`;
    const rightOptionBackgroundUrl = `${imgCdnPrefix}word-option-right.png`;
    const wrongOptionBackgroundUrl = `${imgCdnPrefix}word-option-wrong.png`;
    if (
      this.isUrl(rightOptionBackgroundUrl)
      && this.isUrl(wrongOptionBackgroundUrl)
      && this.isUrl(defaultOptionBackgroundUrl)
    ) {
      if (optionIndex === currentUserAnswer[pageIndex]) {
        if (this.checkCurrentUserAnswer(pageIndex)) {
          return rightOptionBackgroundUrl;
        }
        return wrongOptionBackgroundUrl;
      }
      return defaultOptionBackgroundUrl;
    } else if (
      this.isUrl(defaultOptionBackgroundUrl)
      && this.isUrl(activeOptionBackgroundUrl)
    ) {
      if (optionIndex === currentUserAnswer[pageIndex]) {
        return activeOptionBackgroundUrl;
      }
      return defaultOptionBackgroundUrl;
    }
  }

  getImageBorderColor(optionIndex, pageIndex) {
    const {
      activeBorderColor,
      wrongBorderColor,
      rightBorderColor,
    } = this.props;
    const { currentUserAnswer } = this.state;
    if (wrongBorderColor && rightBorderColor) {
      if (optionIndex === currentUserAnswer[pageIndex]) {
        if (this.checkCurrentUserAnswer(pageIndex)) {
          return rightBorderColor;
        }
        return wrongBorderColor;
      }
    } else if (activeBorderColor) {
      if (optionIndex === currentUserAnswer[pageIndex]) {
        return activeBorderColor;
      }
    }
  }

  getImageIcon(optionIndex, pageIndex) {
    const { imgCdnPrefix } = this.props;
    const { currentUserAnswer } = this.state;
    const rightImageIcon = `${imgCdnPrefix}image-option-right.png`;
    const wrongImageIcon = `${imgCdnPrefix}image-option-wrong.png`;
    if (wrongImageIcon && rightImageIcon) {
      if (optionIndex === currentUserAnswer[pageIndex]) {
        if (this.checkCurrentUserAnswer(pageIndex)) {
          return rightImageIcon;
        }
        return wrongImageIcon;
      }
    }
  }

  checkCurrentUserAnswer(pageIndex) {
    const { currentUserAnswer } = this.state;
    const questionOrder = this.getQuestionOrder(pageIndex);
    const currentAnswer = this.getCurrentAnswer(questionOrder);
    console.log('checkUserAnswer', currentUserAnswer[pageIndex] === currentAnswer);
    console.log('pageIndex', currentUserAnswer[pageIndex]);
    console.log('currentAnswer', currentAnswer);
    return currentUserAnswer[pageIndex] === currentAnswer;
  }

  setCurrentUserAnswer(optionIndex, pageIndex) {
    const { currentUserAnswer } = this.state;
    currentUserAnswer[pageIndex] = optionIndex;
    this.setState({
      currentUserAnswer,
    }, this.slideToNextPage);
  }

  slideToNextPage = (delay = 300) => {
    const timer = setTimeout(() => {
      this.setState(prevState => ({
        currentIndex: ++prevState.currentIndex,
      }));
    }, delay);
    let { currentIndex } = this.state;
    if (++currentIndex >= this.questionLength) {
      clearTimeout(timer);
      setTimeout(() => {
        this.saveUserAnswer();
        route.goHash('result');
      }, delay);
    } else {
      log.logVisit(pg, {
        exam: currentIndex,
      });
    }
  }

  saveUserAnswer() {
    const { currentUserAnswer } = this.state;
    console.log(currentUserAnswer);
    this.props.setAnswer(currentUserAnswer);
  }

  isUrl(str) {
    if (!str) return false;
    const matcher = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
    return matcher.test(str);
  }

  handleClickOption(optionIndex, pageIndex) {
    const questionOrder = this.getQuestionOrder(pageIndex);
    this.setCurrentUserAnswer(optionIndex, pageIndex);
    log.logClick('answerquestion', {
      pg,
      questionindex: pageIndex,
      examoriginindex: questionOrder,
      answeroptionindex: optionIndex,
      questioncorrectindex: this.getCurrentAnswer(questionOrder),
    });
  }

  renderQuestion = (item, pageIndex) => {
    const order = pageIndex + 1;
    const question = this.getCurrentQuestion(item);
    const options = this.getCurrentOption(item);
    const backgroundUrl = this.getCurrentBackgroundUrl(item);

    const { questionTitleColor, questionOptionColor } = this.props;
    // console.log(this.state.currentUserAnswer, this.getAllAnswer());
    return (
      <div
        className="container"
        style={{ backgroundImage: `url(${backgroundUrl})` }}
        key={pageIndex}>
        <div className="question-container">
          <div className="question" style={{ color: questionTitleColor }}>
            <span className="order">{order + '.'}</span><span>{question}</span>
          </div>
          <div className="options">
            {
              options.map((content, optionIndex) => {
                if (this.isUrl(content)) {
                  return (
                    <span
                      key={optionIndex}
                      className="image-option"
                      style={{
                        backgroundImage: `url(${content})`,
                        border: `${this.getRem(4)} solid ${this.getImageBorderColor(optionIndex, pageIndex)}`,
                      }}
                      onClick={() => this.handleClickOption(optionIndex, pageIndex)}>
                      <i
                        className="image-icon"
                        style={{ background: `url(${this.getImageIcon(optionIndex, pageIndex)})` }}
                        />
                    </span>
                  );
                }
                return (
                  <span
                    key={optionIndex}
                    className="word-option"
                    onClick={() => this.handleClickOption(optionIndex, pageIndex)}
                    style={{
                      backgroundImage: `url(${this.getOptionBackgroundUrl(optionIndex, pageIndex)})`,
                      color: questionOptionColor,
                    }}
                    >{content}</span>
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { questionOrder, currentIndex } = this.state;
    // console.log(this.state.currentUserAnswer);
    return (
      <div
        className="page_answer"
        style={{
          width: `${100 * this.questionLength}%`,
          transform: `translate3d(${-640 * currentIndex / 1000 + 'rem'}, 0, 0)`,
        }}>
        {
          questionOrder.map(this.renderQuestion)
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  const conf = state.init.conf.pageAnswer;
  const commonConf = state.init.conf.commonConfig;
  return {
    questionTitleColor: conf.questionTitleColor,
    questionOptionColor: conf.questionOptionColor,
    isShuffleQuestion: conf.isShuffleQuestion,
    shuffleQuestionAmount: conf.shuffleQuestionAmount,
    activeBorderColor: conf.activeBorderColor,
    rightBorderColor: conf.rightBorderColor,
    wrongBorderColor: conf.wrongBorderColor,
    imgCdnPrefix: commonConf.imgCdnPrefix,
  };
};
const mapDispatchToProps = dispatch => ({
  setAnswer: answer => dispatch({
    type: SET_ANSWER,
    data: answer,
  }),
  setQuestionOrder: order => dispatch({
    type: SET_QUESTION_ORDER,
    data: order,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageAnswer);
